import { render, staticRenderFns } from "./brand-article.vue?vue&type=template&id=02cb7310&scoped=true&"
import script from "./brand-article.vue?vue&type=script&lang=js&"
export * from "./brand-article.vue?vue&type=script&lang=js&"
import style0 from "./brand-article.vue?vue&type=style&index=0&lang=stylus&rel=stylesheet%2Fstylus&"
import style1 from "./brand-article.vue?vue&type=style&index=1&id=02cb7310&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02cb7310",
  null
  
)

export default component.exports